import { Tooltip } from "@fluentui/react-components";
import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import {
  IViewEntityField,
  IViewEntityTab,
} from "components/viewDialog/ViewEntityDialog.types";
import { formatDate } from "utils/generalUtils";
import { useViewTagStyles } from "./ViewTag.styles";
import { IViewTagProps } from "./ViewTag.types";

const MAX_FILENAME_LENGTH = 60;

export const ViewTag = (props: IViewTagProps): JSX.Element => {
  const { tag, isOpen, onDismiss } = props;
  const styles = useViewTagStyles();

  const detailsFields: IViewEntityField[] = [
    { label: "Title", value: tag.name || "-" },
    { label: "Description", value: tag.description || "-" },
    { label: "Category", value: tag.category?.title || "-" },
    { label: "Is Public", value: tag.isPublic ? "Yes" : "No" },
    { label: "Created At", value: formatDate(tag.createdAt) },
    { label: "Last Updated", value: formatDate(tag.updatedAt) },
  ];

  const attachmentsValue =
    tag.attachments && tag.attachments.length > 0 ? (
      <div className={styles.attachmentList}>
        {tag.attachments.map((file, index) => {
          const isLong = file.filename.length > MAX_FILENAME_LENGTH;
          const displayName = isLong
            ? file.filename.slice(0, MAX_FILENAME_LENGTH) + "..."
            : file.filename;
          return isLong ? (
            <Tooltip
              key={index}
              content={file.filename}
              relationship="description"
            >
              <div>{displayName}</div>
            </Tooltip>
          ) : (
            <div key={index}>{file.filename}</div>
          );
        })}
      </div>
    ) : (
      "No attachments"
    );

  const attachmentsFields: IViewEntityField[] = [
    { label: "Attachments", value: attachmentsValue },
  ];

  const tabs: IViewEntityTab[] = [
    { key: "details", label: "Details", fields: detailsFields },
    { key: "attachments", label: "Attachments", fields: attachmentsFields },
  ];

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View Knowledge Component"
      tabs={tabs}
    />
  );
};
